export const SET_MAP = 'SET_MAP';
export const ADD_INTERACTION = 'ADD_INTERACTION';
export const CLEAR_INTERACTION_TYPE = 'CLEAR_INTERACTION_TYPE';
export const SET_BASEMAPS = 'SET_BASEMAPS';
export const SET_ACTIVE_BASEMAP = 'SET_ACTIVE_BASEMAP';

